import { toaster } from "../components/toaster";
import { DefaultService, UserProfileSchema } from "../generated";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import camelize, { Camelize } from "camelize-ts";
import snakify from "snakify-ts";

export const useUserProfile = () => {
  return useQuery({
    queryKey: ["userProfile"],
    queryFn: DefaultService.fakturUsersViewsUserProfileApi,
    select: (data) => {
      const camelizedData = camelize(data);
      return {
        ...camelizedData,
        bankAccounts: data.bank_accounts?.map((bank) => camelize(bank)) || [],
      };
    },
  });
};

export const useUpdateUserProfile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["updateUserProfile"],
    mutationFn: (data: Camelize<UserProfileSchema>) =>
      DefaultService.fakturUsersViewsUpdateUserApi({
        // @ts-ignore
        requestBody: snakify(data),
      }),
    onSuccess: (data) => {
      toaster.success({ title: "Profil oppdatert!" });
      queryClient.setQueryData(["userProfile"], data);
    },
  });
};
